/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiTopic } from './Topic';
import { ApiTopicItem } from './TopicItem';

export interface HomeRowRequest {

    /**
     * Valid types: `topic`, `must_see`
     */
    type?: string;

    /**
     * Home row title
     */
    title?: string;

    /**
     * Topic object for topic rows
     */
    topic?: ApiTopic;

    topic_items?: ApiTopicItem[];

}

@Model('HomeRow')
export class ApiHomeRow extends BaseModel implements HomeRowRequest {

    /**
     * Valid types: `topic`, `must_see`
     */
    
    
    type: string;

    /**
     * Home row title
     */
    
    
    title: string;

    /**
     * Topic object for topic rows
     */
    @Type('ApiTopic')
    @Expand()
    topic: ApiTopic;

    @Type('ApiTopicItem')
    @Expand()
    topic_items: ApiTopicItem[];

}
